function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 19.056a2.838 2.838 0 1 0 0-5.675 2.838 2.838 0 0 0 0 5.675z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 11.241c-3.781 0-7.316.55-9.892 1.448-1.523.531-2.692 1.182-3.464 1.842-.79.676-1.063 1.27-1.063 1.689 0 .438.3 1.078 1.147 1.804.825.707 2.067 1.4 3.67 1.948 2.525.863 5.94 1.284 9.602 1.284 3.562 0 6.907-.446 9.413-1.277 1.664-.55 2.956-1.242 3.815-1.95.883-.727 1.191-1.366 1.191-1.809 0-.415-.283-1.013-1.106-1.7-.801-.668-2.006-1.324-3.553-1.857-2.568-.884-6.017-1.422-9.76-1.422zm-10.412-.044C8.368 10.227 12.087 9.66 16 9.66c3.876 0 7.506.556 10.275 1.509 1.668.574 3.06 1.31 4.05 2.138.97.808 1.675 1.808 1.675 2.913 0 1.14-.74 2.184-1.767 3.03-1.051.865-2.533 1.637-4.323 2.23-2.714.899-6.239 1.356-9.91 1.356-3.754 0-7.36-.427-10.114-1.368-1.737-.594-3.17-1.374-4.187-2.244C.706 18.374 0 17.334 0 16.22c0-1.088.67-2.08 1.617-2.89.963-.824 2.323-1.559 3.97-2.133z",
  clipRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.154 3.852c-.98.36-2.15 1.076-3.384 2.15-2.048 1.783-4.238 4.502-6.107 7.745l-.103.177c-1.833 3.218-3.085 6.483-3.585 9.115-.3 1.584-.32 2.922-.134 3.921.19 1.022.568 1.555.93 1.765.38.219 1.085.279 2.137-.093 1.024-.361 2.246-1.09 3.52-2.205 2.01-1.757 4.08-4.505 5.91-7.677 1.78-3.086 3.065-6.207 3.597-8.792.353-1.716.4-3.181.216-4.28-.188-1.127-.589-1.714-.972-1.935-.36-.207-1.019-.26-2.025.11zm2.815-1.478c.988.57 1.522 1.731 1.741 3.044.225 1.343.153 3.012-.227 4.858-.577 2.801-1.942 6.083-3.776 9.263-1.876 3.252-4.048 6.163-6.238 8.078-1.382 1.208-2.774 2.06-4.035 2.506-1.233.435-2.486.528-3.451-.029-.943-.543-1.468-1.62-1.696-2.844-.233-1.247-.19-2.792.136-4.506.549-2.893 1.915-6.397 3.87-9.787l.252-.438h.004c1.881-3.169 4.071-5.87 6.184-7.71 1.331-1.158 2.664-1.995 3.875-2.44 1.185-.436 2.404-.547 3.36.005z",
  clipRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.823 3.852c.98.36 2.15 1.076 3.384 2.15 2.049 1.783 4.238 4.502 6.108 7.745l.102.177c1.833 3.218 3.085 6.483 3.585 9.115.3 1.584.321 2.922.135 3.921-.191 1.022-.569 1.555-.932 1.765-.38.219-1.084.279-2.136-.093-1.024-.361-2.245-1.09-3.52-2.205-2.01-1.757-4.08-4.505-5.91-7.677-1.779-3.086-3.064-6.207-3.596-8.792-.354-1.716-.4-3.181-.217-4.28.189-1.127.589-1.714.972-1.935.36-.207 1.02-.26 2.025.11zM8.01 2.374c-.988.57-1.522 1.731-1.742 3.044-.225 1.343-.153 3.012.227 4.858.577 2.801 1.942 6.083 3.776 9.263 1.876 3.252 4.048 6.163 6.238 8.078 1.383 1.208 2.774 2.06 4.035 2.506 1.233.435 2.486.528 3.451-.029.943-.543 1.468-1.62 1.696-2.844.233-1.247.19-2.792-.135-4.506-.55-2.893-1.916-6.397-3.87-9.787l-.253-.438h-.004c-1.88-3.169-4.071-5.87-6.184-7.71-1.33-1.158-2.664-1.995-3.875-2.44-1.185-.436-2.403-.547-3.36.005z",
  clipRule: "evenodd"
});

var SvgReactNative = function SvgReactNative(props) {
  return React.createElement("svg", _extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "989908be1817f6af5d232b4369118b31.svg";
export { SvgReactNative as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/react-native.svg
// module id = null
// module chunks = 